import { render, staticRenderFns } from "./move-structure-modal.vue?vue&type=template&id=5843d404&scoped=true"
import script from "./move-structure-modal.vue?vue&type=script&lang=js"
export * from "./move-structure-modal.vue?vue&type=script&lang=js"
import style0 from "./move-structure-modal.vue?vue&type=style&index=0&id=5843d404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5843d404",
  null
  
)

export default component.exports